/**
 * HeaderIndustriesList Component
 *
 * Renders a horizontally scrollable list of industry chips in company details headers.
 * Displays an empty placeholder when no industries are available.
 *
 * Used in:
 * - Mobile header (<800px) with emptyClassName="no-industries"
 * - Mobile header (>=800px merged row) with emptyClassName="no-industries"
 * - Desktop header with emptyClassName="normal-text"
 */

import HorizontalGrabScroll from '../../../containers/HorizontalGrabScroll';
import { PUNCTUATION } from '../../../../utils/constants/notation';

/**
 * @param {Object} props
 * @param {string[]} props.industries - Array of industry names
 * @param {string} props.emptyClassName - CSS class for empty state placeholder
 */
const HeaderIndustriesList = ({ industries, emptyClassName }) => {
  const hasIndustries = industries?.length > 0;

  if (!hasIndustries) {
    return <div className={emptyClassName}>{PUNCTUATION.EMPTY_VALUE}</div>;
  }

  return (
    <>
      <HorizontalGrabScroll className="industries-scrollable-container">
        {industries.map((industry, idx) => (
          <div className="industry noselect" key={idx}>
            {industry}
          </div>
        ))}
      </HorizontalGrabScroll>
      <div className="fade-left" />
      <div className="fade-right" />
    </>
  );
};

export default HeaderIndustriesList;
